import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import Preview from '@mui/icons-material/Preview';
import DeleteIcon from '@mui/icons-material/Delete';
import {Button} from '@mui/material';
import { useDispatch } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import '../../../Static/Master/firmtable.css';
import { delItemMaterial } from '../../../Store/PHPSlice/Item';

const TableBody = ({
    itemId,
    itemNm,
    cloth_name,
    serialNumber,
    selected,
}) => {
    const dispatch = useDispatch();

  const handleViewClick = (itemId, cat) => {
 //   alert("itemId=>"+itemId);
   // alert("cat=>"+cat);
    window.open(
        `/pricelist-view/${itemId}/${cat}`,
        '_blank',
        'width=800,height=600,scrollbars=yes,resizable=yes'
    );
};


    const handleDeleteClick = () => {
        const isConfirmed = window.confirm(
            'Are you sure you want to delete this Material?'
        );

        if (!isConfirmed) return;

        const postobj = {
            itemId,
            cloth_name,
        };

        dispatch(delItemMaterial(postobj))
            .then(() => {
                alert('Record Deleted Successfully');
                window.location.reload();
            })
            .catch(() => {
                toast.error('Failed to delete record');
            });
    };

    return (
        <>
            <TableRow hover selected={selected}>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                    {serialNumber}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                    <Typography variant="subtitle2" noWrap>
                        {itemNm}
                    </Typography>
                </TableCell>

                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                    <Typography variant="subtitle2" noWrap>
                        {cloth_name}
                    </Typography>
                </TableCell> */}


                <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                    <Button
    variant="contained"
    size="small"
      color="secondary"

    onClick={() => handleViewClick(itemId,'MU')}   // 👈 pass parameter here
  >
    MU
  </Button>
                </TableCell>
                  <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                    <Button
    variant="contained"
    size="small"
      color="success"

    onClick={() => handleViewClick(itemId,'S')}   // 👈 pass parameter here
  >
    S
  </Button>
                </TableCell>
                           <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                    <Button
    variant="contained"
    size="small"
      color="error"

    onClick={() => handleViewClick(itemId,'N')}   // 👈 pass parameter here
  >
    N
  </Button>
                </TableCell>


                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                    <DeleteIcon
                        className="cursor-pointer"
                        onClick={handleDeleteClick}
                    />
                </TableCell> */}
            </TableRow>

            <ToastContainer />
        </>
    );
};

export default TableBody;
